
export default {
  data() {
    return {
      tab: 0,
      userAccess: [
        {
          id: "report",
          label: "Report",
          regularUser: true,
          admin: false,
          superAdmin: false
        },
        {
          id: "add-new-item",
          label: "Add New Item",
          regularUser: false,
          admin: false,
          superAdmin: false
        },
        {
          id: "modify-item",
          label: "Modify Item",
          regularUser: false,
          admin: false,
          superAdmin: false
        },
        {
          id: "add-modify-channels",
          label: "Add/Modify Channels",
          regularUser: false,
          admin: false,
          superAdmin: false
        },
        {
          id: "add-new-branches",
          label: "Add New Branches",
          regularUser: false,
          admin: false,
          superAdmin: false
        },
        {
          id: "appstore-access",
          label: "Appstore Access",
          regularUser: false,
          admin: false,
          superAdmin: false
        },
        {
          id: "advance-payment",
          label: "Advance Payment",
          regularUser: false,
          admin: false,
          superAdmin: false
        }
      ],
      userAccessCopy: []
    };
  },
  computed: {
    hasUnsavedChanges() {
      return (
        JSON.stringify(this.userAccessCopy) !== JSON.stringify(this.userAccess)
      );
    }
  },
  beforeMount() {
    this.userAccessCopy = JSON.parse(JSON.stringify(this.userAccess));
  },
  methods: {
    handleSave() {
      console.log("Changes Saved");
    },
    handleTabChange() {
      console.log("Tab Changed");
    }
  }
};
